<template>
  <h2 class="text-3xl mob:text-2xl font-semibold">
    <slot />
  </h2>
</template>
